import { useTheme } from '@emotion/react'
import { Loader } from 'chaoskit/src/components'

const Loading = () => {
  const theme = useTheme()

  return (
    <div css={{ textAlign: 'center' }}>
      <Loader
        css={{
          fontSize: theme.fontSize['3xlarge'],
          color: theme.color.primary.base,
        }}
      />
    </div>
  )
}

export default Loading
